import * as React from "react";
const SVGComponent = (props) => (
    <svg width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.3869 0.164063L6.79688 4.74406L2.20687 0.164063L0.796875 1.57406L6.79688 7.57406L12.7969 1.57406L11.3869 0.164063Z" fill="black" fill-opacity="0.54" />
    </svg>
);
export default SVGComponent;
